import { PAGE_TEMPLATES, COMPONENT_TEMPLATES } from "./utils/constants/templates";
import Standard from "./pages/magnolia/standard/Standard";
import ProductOverview from "./pages/magnolia/productOverview/ProductOverview";
import ProductDetail from "./pages/magnolia/productDetail/ProductDetail";
import Hero from "./components/magnolia/hero/Hero";
import HeroSlide from "./components/magnolia/hero/HeroSlide";
import Headline from "./components/magnolia/Headline";

export const componentMappings = {
    [PAGE_TEMPLATES.HOME]: Standard,
    [PAGE_TEMPLATES.STANDARD]: Standard,
    [PAGE_TEMPLATES.PRODUCT_OVERVIEW]: ProductOverview,
    [PAGE_TEMPLATES.PRODUCT_DETAIL]: ProductDetail,
    [COMPONENT_TEMPLATES.HERO]: Hero,
    [COMPONENT_TEMPLATES.HERO_SLIDE]: HeroSlide,
    [COMPONENT_TEMPLATES.HEADLINE]: Headline,
};
